// extracted by mini-css-extract-plugin
module.exports = {"ProseMirror":"NextAnswer_ProseMirror__2xWTr","nextAnswer":"NextAnswer_nextAnswer__2xbnu","rotate-shadow":"NextAnswer_rotate-shadow__2M5_A"};